<template>
    <v-modal ref="modal" @opened="modalOpened" >
        <slot slot="title">{{ $t('country.label.edit_costs') }}</slot>
        <slot slot="buttonContent">
            <button type="button" class="c-button c-button--tiny c-button--alpha">
                <svgicon name="search" class="svg-icon svg-fill"></svgicon>
            </button>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-input v-model="currencyCode" name="currencyCode" :fluid="true" :disabled="true">
                            <slot slot="label">{{ $t('country.label.currency') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="ShippingCosts" name="shippingCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.shipping_costs') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="DropShipmentCosts" name="dropShipmentCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.dropshipment_costs') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="FreeDeliveryShippingCosts" name="freeDeliveryShippingCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.free_delivery_shipping_costs') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="FreeDeliveryDropShipmentCosts" name="freeDeliveryDropShipmentCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.free_delivery_dropShipment_costs') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="editCosts" type="button" class="c-button c-button--alpha">{{ $t('country.button.edit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>       
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VFormRow from '@/components/form/Row'
    import VInput from '@/components/form/Input'
    import VLabel from '@/components/form/Label'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VFormRow,
            VInput,
            VLabel
        },
        data() {
            return {
                ShippingCosts: 0,
                DropShipmentCosts: 0,
                FreeDeliveryShippingCosts: 0,
                FreeDeliveryDropShipmentCosts: 0
            }
        },
        props: {
            costs: Object,
            currencyCode: String
        },
        methods: {
            editCosts() {
                this.costs.ShippingCosts = this.ShippingCosts;
                this.costs.DropShipmentCosts = this.DropShipmentCosts;
                this.costs.FreeDeliveryShippingCosts = this.FreeDeliveryShippingCosts;
                this.costs.FreeDeliveryDropShipmentCosts = this.FreeDeliveryDropShipmentCosts;
                this.$refs.modal.closeDialog();        
            },
            modalOpened() {
                this.ShippingCosts = this.costs.ShippingCosts;
                this.DropShipmentCosts = this.costs.DropShipmentCosts;
                this.FreeDeliveryShippingCosts = this.costs.FreeDeliveryShippingCosts;
                this.FreeDeliveryDropShipmentCosts = this.costs.FreeDeliveryDropShipmentCosts;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";
</style>


// WEBPACK FOOTER //
// src/components/countries/EditCosts.vue